





























import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";

@Component({ components: { VModal } })
export default class MediumTypeModal extends Vue {
  @Ref() readonly modal!: VModal;

  @Prop({ default: "" }) readonly title!: string;

  id = "";

  open(id: string) {
    this.id = id;
    this.modal.show();
  }

  close() {
    this.modal.hide();
  }

  onDestroy() {
    this.$emit("destroy", this.id);
    this.close();
  }

  onCancel() {
    this.close();
  }
}
